module.exports = __webpack_public_path__ + "img/qz4.0-1.4639270a.jpg";